/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'

import * as styles from '@/components/form/form.module.scss'
import FormContext from '@/components/form/form-context'

interface EmailFieldProps {
  align?: 'leftLabel' | 'centerLabel' | 'item'
}

const EmailField: React.FC<EmailFieldProps> = ({ align = 'item' }) => {
  const { classes } = useContext(FormContext)

  const {
    formState: { errors },
    register
  } = useFormContext()
  return (
    <div className={[styles[align], classes?.input].filter(Boolean).join(' ')}>
      <label htmlFor="email">Corporate E-mail*</label>
      <input
        id="email"
        type="text"
        {...register('email')}
        data-testid="email"
      />
      {errors?.email &&
        ['string.empty', 'string.email'].includes(
          errors.email?.type as string
        ) && <span>Please, fill the E-mail</span>}
      {errors?.email && errors?.email?.type === 'any.custom' && (
        <span>Please, use a corporate e-mail address</span>
      )}
    </div>
  )
}
export default EmailField
